import { designTokens } from '@cinch-labs/design-system'
import cx from 'classnames'

import Heart from '../assets/heart.svg'
import styles from './save-button.module.css'

export const SAVE_CAR = 'Save car to your profile'
export const UNSAVE_CAR = 'Remove car from saved list'

enum GRADIENT_IDS {
  alpha = 'svg-gradient-alpha',
  bravo = 'svg-gradient-bravo',
  charlie = 'svg-gradient-charlie',
  delta = 'svg-gradient-delta',
}
const gradientFill = `url(#${GRADIENT_IDS.alpha})`

export const SaveButton: React.FC<{
  onClick: () => void
  isSaved: boolean
  isPending: boolean
  size: string
  className?: string
  children?: React.ReactNode
}> = ({ onClick, isSaved, size, className, children, isPending = false }) => {
  const classNames = cx([styles.button, className], {
    [styles.loading]: isPending,
  })
  const padding = designTokens.customProperties.ds.font.size['3xs']
  const height = Number.parseInt(size, 10) + Number.parseInt(padding, 10)

  return (
    <button
      style={{
        borderRadius: height * 0.5,
        visibility: isPending ? 'hidden' : 'visible',
      }}
      className={classNames}
      disabled={isPending}
      data-testid={isSaved ? 'unsave-car-button' : 'save-car-button'}
      title={isSaved ? UNSAVE_CAR : SAVE_CAR}
      type="button"
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
    >
      <Heart
        role="presentation"
        height={size}
        width={size}
        style={{
          display: 'inline-flex',
          width: size,
          height: size,
          fill: isSaved && !isPending ? gradientFill : 'none',
          stroke: !isPending ? gradientFill : 'none',
          strokeWidth: isPending ? 0 : 2.5,
        }}
      />
      {children}
    </button>
  )
}
